import React, { useState, useEffect } from "react";
import "react-tooltip/dist/react-tooltip.css";
import Button from "../../../../common/Button";
// import ChartNav from "../../../../common/ChartNav";
import { useSelector, useDispatch } from "react-redux";
import {
  updateClinicalService,
  updateMedicationReview,
} from "../../../../../redux/modules/clinical-services/actions";
// import {
//   fetchAllergy,
//   updateAllergy,
//   createAllergy,
// } from "../../../../../redux/modules/patient/actions";
// import Medications from "../../medications/medications";
import Steps from "../../Steps";
import { useParams } from "react-router-dom";
import { calculateAgeYear } from "../../../../../helpers/functions";
import { ClinicalServiceTypes, getValidStep } from "../../../text/data";
import InterventionCreate from "../medication/interventionCreate";
// import SubNavigation from "../../common/sub-navigation";
// import AllergyTable from "../../../clinical-details/components/allergy/table";
// import AllergyInformationHeader from "../../../clinical-details/components/allergy/allergy-information-header";
// import AllergyCreate from "../../../clinical-details/components/allergy/AllergyCreate";
import PatientAllergies from "../../../clinical-details/components/allergy/PatientAllergies";

const Allergies = () => {
  const dispatch = useDispatch();
  const { clinicalServiceObj, clinicalServiceName, clinicalServiceSteps } = useSelector(
    (state) => state.clinicalService
  );
  const { currentStep, currentSubStep } =
    clinicalServiceObj.initialAssessment.initialAssessmentForm;
  const { serviceId } = useParams(); //id: patientId, 
  const { patient } = useSelector((state) => state.patients);

  // const [showCreateSlider, setShowCreateSlider] = useState(false);
  // const [confirmNoAllergy, setConfirmNoAllergy] = useState(false);
  // const [selectedAllergy, setSelectedAllergy] = useState(null);
  // const [create, setCreate] = useState(true);

  // const filterOptions = [
  //   { value: "selectFilter", label: "Select Filter" },
  //   { value: "all", label: "All" },
  //   { value: "active", label: "Active" },
  //   { value: "inactive", label: "Inactive" },
  // ];

  // //Dhruv States
  // const [isActiveAllergyPresent, setIsActiveAllergyPresent] = useState(null);
  // const [allAllergies, setAllAllergies] = useState([]);
  const [showInterventionDialog, setShowInterventionDialog] = useState(false);
  const [validateStep, setValidateStep] = useState(false);
  const [confirmedAllergies, setConfirmedAllergies] = useState(
    clinicalServiceObj.initialAssessment?.initialAssessmentForm
      ?.clinicalAssessment?.confirmedAllergy ?? []
  );
  
  // Track if user has manually confirmed "No Known Allergy" in current session
  const [noKnownAllergyConfirmedLocally, setNoKnownAllergyConfirmedLocally] = useState(false);
  const [isNavigating, setIsNavigating] = useState(false);

  // Computed function to check if "No Known Allergy" has been confirmed
  const isNoKnownAllergyConfirmed = () => {
    const isAllergyProcessed = clinicalServiceObj.initialAssessment?.initialAssessmentForm?.clinicalAssessment?.allergy === true && confirmedAllergies.length === 0;
    return isAllergyProcessed || noKnownAllergyConfirmedLocally;
  };

  // Simple function to handle allergy confirmation updates
  const handleConfirmedAllergyUpdate = (allergies) => {
    if (isNavigating) return;
    setConfirmedAllergies(allergies);
    setNoKnownAllergyConfirmedLocally(allergies.length === 0);
    
    // Check if "No Known Allergy" is confirmed (allergy === true but no confirmed allergies in clinical service)
    const isNoAllergyConfirmed = clinicalServiceObj?.initialAssessment?.initialAssessmentForm?.clinicalAssessment?.allergy === true && allergies.length === 0;
    
    // Immediately save confirmed allergies to clinical service object
    // allergy should be true if: there are confirmed allergies OR "No Known Allergy" was confirmed
    const updatedSteps = {
      clinicalAssessment: {
        allergy: allergies.length > 0 || isNoAllergyConfirmed,
        confirmedAllergy: allergies,
      },
    };

    if (clinicalServiceName === ClinicalServiceTypes.AllergicRhinitis) {
      dispatch(updateClinicalService(serviceId, updatedSteps));
    } else if (
      clinicalServiceName === ClinicalServiceTypes.MedicationReview
    ) {
      dispatch(updateMedicationReview(serviceId, updatedSteps));
    }
  };

  const onNext = async () => {
    if (currentStep <= clinicalServiceSteps.length) {
      if (isNavigating) return;
      setIsNavigating(true);
      const { nextStep, nextSubStep } = getValidStep(clinicalServiceSteps, currentStep, currentSubStep, 1);
      // const updatedAllergy = {
      //   noKnownAllergies: confirmNoAllergy,
      //   allergies: allAllergies,
      // };
      // dispatch(createAllergy(patientId, updatedAllergy));
      const updatedSteps = {
        clinicalAssessment: {
          allergy: confirmedAllergies.length > 0 || isNoKnownAllergyConfirmed(),
          confirmedAllergy: confirmedAllergies,
        },
        currentStep: nextStep,
        currentSubStep: nextSubStep,
        serviceSteps: clinicalServiceSteps
      };

      try {
        if (clinicalServiceName === ClinicalServiceTypes.AllergicRhinitis) {
          await dispatch(updateClinicalService(serviceId, updatedSteps));
        } else if (
          clinicalServiceName === ClinicalServiceTypes.MedicationReview
        ) {
          await dispatch(updateMedicationReview(serviceId, updatedSteps));
        }
      } finally {
        setIsNavigating(false);
      }
    }
  };

  const onPrevious = async () => {
    if (isNavigating) return;
    setIsNavigating(true);

    const { nextStep, nextSubStep } = getValidStep(clinicalServiceSteps, currentStep, currentSubStep, -1);
    const updatedSteps = { currentStep: nextStep, currentSubStep: nextSubStep, serviceSteps: clinicalServiceSteps };

    try {
      if (clinicalServiceName === ClinicalServiceTypes.MedicationReview) {
        await dispatch(updateMedicationReview(serviceId, updatedSteps));
      } else {
        await dispatch(updateClinicalService(serviceId, updatedSteps));
      }
    } finally {
      setIsNavigating(false);
    }
  };

  return (
    <div className="relative flex flex-col flex-1 w-full gap-4 bg-white">
      <div className="flex flex-col flex-1">
        <div className="flex flex-1 gap-4">
              <PatientAllergies
                confirmedAllergy={confirmedAllergies}
                clinicalServiceName={clinicalServiceName}
                updateConfirmedAllergy = {handleConfirmedAllergyUpdate}
                updateValidation = {(validate) => {setValidateStep(validate)}}
                allergiesProcessed={clinicalServiceObj.initialAssessment?.initialAssessmentForm?.clinicalAssessment?.allergy || isNoKnownAllergyConfirmed()}
                clinicalServiceObj={clinicalServiceObj}
              />
        </div>
      </div>

      <div className="flex items-center justify-between space-x-4  rounded">
        <div className="w-full ">
          <Steps position="bottom" stepsList={clinicalServiceSteps} />
        </div>
        <div className="flex items-center gap-3 ">
          <Button
            type="primary-outline"
            text="Back"
            className="w-[200px] max-h-[52px] !rounded-[30px]"
            onClick={() => {
              onPrevious();
            }}
          />
          <Button
            type="primary"
            text="Next"
            className={`w-[200px] max-h-[52px] !rounded-[30px] ${
              validateStep ? "" : "opacity-40 pointer-events-none"
            }`}
            onClick={() => {
              onNext();
            }}
          />
        </div>
      </div>

      <InterventionCreate
        open={showInterventionDialog}
        onClose={(value) => setShowInterventionDialog(false)}
      />
    </div>
  );
};

export default Allergies;
